export default "__VITE_ASSET__c454d88a__"